import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from "react-oidc-context"
import { Menu, MenuItem } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
// import dashboardRoutes from 'constants/dashboardRoutes'
import styles from './Header.module.sass'
import { resetUserData } from '../../redux/userReducer'
import { resetPortfolioData } from '../../redux/portfolioReducer'
import { resetMiscData } from '../../redux/miscReducer'
import TopTokenSlider from './TopTokenSlider'
import NotificationDrawer from './NotificationDrawer'
// import ResetPasswordModal from 'components/Modal/ResetPassword'
import { RootState } from 'redux/store'
import GuidedTour from 'components/Modal/GuidedTour'

const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

function Header({ setNavLinksOpen, navLinksOpen, onRefreshTokens }: any) {
  const auth = useAuth()
  // const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userName = auth.user?.profile["cognito:username"]
  const [resetModalOpen, setResetModalOpen] = useState(false)
  const [isOpenNotificationDrawer, setIsOpenNotificationDrawer] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  // set status for guided tour
  const [isTourActive, setIsTourActive] = useState(false);
  
  // Redux state
  const notificationData = useSelector((state: RootState) => state.user.notificationData)

  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSignOut = async () => {
    dispatch(resetUserData());
    dispatch(resetPortfolioData());
    dispatch(resetMiscData());
    await auth.signoutRedirect({
      extraQueryParams: {
        client_id: clientId,
        logout_uri: "https://www.astroteklabs.com"
      },
    });
    handleClose();
  };

  const toggleDrawer = () => setIsOpenNotificationDrawer(false)

  return (
    <div className={styles.header}>
      <div
        className={styles.hamburgerMenu}
        onClick={() => setNavLinksOpen(!navLinksOpen)}
      >
        {navLinksOpen ? <CloseIcon /> : <MenuIcon />}
      </div>
      {/* <TopTokenSlider /> */}
      <TopTokenSlider onRefresh={onRefreshTokens} />
      <div className={styles.pageSettings}>
        <div className={styles.userDropdown} onClick={handleClick}>
          <div className={styles.userName}>{userName}</div>
          <ExpandMoreIcon />
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            marginTop: '5px',
            '.MuiMenu-list': { background: '#1B1B24' },
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              setIsTourActive(true);
            }}
          >
            <div className={styles.menuItem}> App Tour</div>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              navigate('/billing');
            }}
          >
            <div className={styles.menuItem}>Billing</div>
          </MenuItem>
          <MenuItem onClick={handleSignOut}>
            <div className={styles.menuItem}>Log Out</div>
          </MenuItem>
        </Menu>
      </div>
      <NotificationDrawer
        isOpenNotificationDrawer={isOpenNotificationDrawer}
        toggleDrawer={toggleDrawer}
        notificationData={notificationData}
      />
      {/* <ResetPasswordModal
        open={resetModalOpen}
        onClose={() => setResetModalOpen(false)}
      /> */}
      {isTourActive && (
        <GuidedTour 
          onComplete={() => setIsTourActive(false)}
        />
      )}
    </div>
  )
}

export default Header